module.exports = __webpack_public_path__ + "asset/image-team-90cd536a50f1c719.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/team.png
// module id = Ic5U
// module chunks = 3